<template>
  <div class="news-center">
    <div class="row1 hp_cz_center">
      <span class="all">全部消息</span>
      <span class="unread" v-if="messageCount == 0">没有未读消息</span>
      <span class="unread" v-else>您有{{ messageCount }}条未读消息</span>
      <a-popconfirm title="确认清空消息？" ok-text="是" cancel-text="否" @confirm="hideMsg">
        <icon-font v-if="messageCount != 0" type="icon-qiangzhiqingchu" class="qiangzhiqingchu" />
      </a-popconfirm>
    </div>
    <div class="news" ref="news">
      <div
        class="new_demo cursor-point hp_space_between"
        v-for="(item, index) in messageList"
        :key="index"
        @click="goNext(item.bizId)"
      >
        <div class="hp_cz_center">
          <a-badge :dot="!item.isRead">
            <img :src="item.img" alt />
          </a-badge>
          <div style="margin-left: 14px;">
            <div class="new">{{ item.title }}</div>
            <div class="detail">{{ item.content }}</div>
          </div>
        </div>
        <div class="time">{{ item.createTime }}</div>
      </div>
    </div>
    <template v-if="total>0">
      <div>
        <a-pagination
          show-quick-jumper
          :default-current="current"
          :total="total"
          @change="onChange"
        />
        <br />
      </div>
    </template>
     <a-back-top class="backTop" v-show="false" ref="backtop">
        <icon-font type="icon-huidingbu" />
      </a-back-top>
  </div>
</template>
<script>
import { getMsgList, hideMsgList, getUnreadList } from "@/api/user-center";
import { logout } from "@/api/user";
import { ls } from "@/utils/tool";
import { removeToken } from "@/utils/auth";
export default {
  data() {
    return {
      show: true,
      memberId: "",
      totalmessage: [],
      messageCount: 0,
      current: 1,
      total: 0,
    };
  },
  created() {
    this.memberId = JSON.parse(localStorage.getItem("sysUser")).id;
    this.getData();
  },
  methods: {
    onChange(pageNumber) {
      window.scrollTo(0,0)
      this.current = pageNumber;
    },
    async getData() {
      let data = {
        bizType: 1,
        memberId: this.memberId,
      };
      let res = await getMsgList(data);
      if (res.code == 200) {
        this.total = res.data.length;
        console.log(res.data.length, this.total);
        this.totalmessage = res.data;
      } else {
        this.totalmessage = [];
      }
      let re = await getUnreadList(data);
      this.$store.commit("changeMsgCount", re.data);
      this.messageCount = re.data;
    },
    //前往下个页面
    goNext(id) {
      this.$router.push({
        path: "/user-center/register/register-detail",
        query: {
          id: id,
          pageType: "msg",
        },
      });
    },
    async hideMsg() {
      let data = {
        memberId: this.memberId,
      };
      let res = await hideMsgList(data);
      this.getData();
    },
  },
  mounted() {},
  computed: {
    messageList() {
      let { totalmessage, current, total } = this;
      let min, max;
      if (totalmessage.length > 0 && totalmessage.length <= 10) {
        return totalmessage;
      }
      if (totalmessage.length > 10) {
        if (current == 1) {
          min = 0;
          max = 10;
        } else {
          min = current * 10 - 10;
          max = min + 10;
        }
        if (max > total - 1) {
          max = total - 1;
        }
        console.log(min,max)
        return totalmessage.slice(min, max);
      }
      return [];
    },
  },
};
</script>
<style lang="less" scoped>
.news-center {
  margin-left: 67px;
  .row1 {
    margin-bottom: 28px;
    .all {
      font-size: 26px;
      font-weight: 400;
      color: #333333;
      margin-right: 22px;
    }
    .unread {
      font-size: 18px;
      font-weight: 400;
      color: #666666;
    }
    .qiangzhiqingchu {
      width: 17px;
      color: #ff0000;
    }
  }
  .news {
    .new_demo {
      padding: 22px 32px;
      // width: 850px;
      width: 99%;
      height: 103px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.3);
      border-radius: 6px;
      margin-bottom: 20px;
      img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        overflow: hidden;
      }
      .new {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 8px;
      }
      .detail {
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .time {
        font-size: 16px;
        color: #c5c5c5;
      }
    }
  }
}
</style>
